export default __webpack_public_path__ + "static/media/Step-6.88488364.webm";